import { useState } from "react";
import "./ExpenseForm.css";

const ExpenseForm = (props) => {
    const [titleChange,setTitleChange] = useState("");
    const [amountChange,setAmountChange] = useState("");
    const [dateChange,setDateChange] = useState("");

    const titleChangeHandler = (event) =>{
        setTitleChange(event.target.value);
    }
    const amountChangeHandler = (event) =>{
        setAmountChange(event.target.value);
    }
    const dateChangeHandler = (event) =>{
        setDateChange(event.target.value);
    }
    const submitHandler = (event) =>{
        event.preventDefault();
        console.log(event);
        const expenseData = {
            title : titleChange,
            amount : amountChange,
            date : new Date(dateChange),
        };
        props.onSaveExpenseData(expenseData);
        console.log(expenseData);
        setTitleChange("");
        setAmountChange("");
        setDateChange("");
    
    }
    
    return (
        <form onSubmit={submitHandler}>
            <div className="new-expense__controls">
                <div className="new-expense__control">
                    <label>Title</label>
                    <input type="text" value={titleChange} onChange={titleChangeHandler}/>
                </div>
                <div className="new-expense__control">
                    <label>Amount</label>
                    <input type="number" value={amountChange} min="0.01" steps="0.01" onChange={amountChangeHandler} />
                </div>
                <div className="new-expense__control">
                    <label>Date</label>
                    <input type="date" value={dateChange} min="2022-01-01" max="2025-12-31"  onChange={dateChangeHandler}/>
                </div>
            </div>
            <div className="new-expense__actions"> 
                <button className="new-expense__button" type="button" onClick={props.onCancel}>Cancel</button>
                <button className="new-expense__button" type="submit">Add Expense</button>
            </div>
        </form>
    )
}

export default ExpenseForm;